class InteractiveObject {

    constructor(object, highlightMaterial, { onClick } = {}) {
        this.name = object.id;
        this.object = object;
        this.onClickCallback = onClick;

        this.meshes = [];
        
        object.traverse( child => {
            if (child.isMesh) {
                this.meshes.push(child);
            }
        });

        this.highlightMaterial = highlightMaterial;

        this.intersected = false;
        this.baseMaterials = this.meshes.map( mesh => mesh.material);
    }

    onMouseEnter() {
        this.intersected = true;
        
        for (let i = 0; i < this.meshes.length; i++) {
            this.meshes[i].material = this.highlightMaterial;    
        }
    }

    onMouseLeave() {
        this.intersected = false;

        for (let i = 0; i < this.meshes.length; i++) {
            this.meshes[i].material = this.baseMaterials[i];
        }
    }

    onClick() {
        if (typeof this.onClickCallback === 'function') {
            this.onClickCallback();
        }
    }

}

export default InteractiveObject;